import React from 'react'
import ModelItemContainer from './ModelItemContainer'
import { modelShape } from '../../shapes'

const ModelItem = ({ model }) => (
  <ModelItemContainer model={model} data-test="component-model-item" />
)

ModelItem.propTypes = {
  model: modelShape.isRequired
}

export default ModelItem
